var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.indexPage,{attrs:{"parentData":_setup.parentData},on:{"set-loading":_setup.setLoading}})
}
var staticRenderFns = []

export { render, staticRenderFns }